import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, LabelText, TitleText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassTicket = () => {
  return (
    <View style={styles.container}>
      <LabelText sizeMatch={['12', '14']}>Ends January 31st</LabelText>
      <TitleText sizeMatch={['64', '80']}>Sweetpass</TitleText>
      <BodyText sizeMatch={['24', '40']}>$3 off once per day</BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    maxHeight: 352,
    backgroundColor: theme.colors.WHITE,
    gap: theme.spacing['2'],
    padding: theme.spacing['6'],
    borderRadius: theme.spacing['10'],
  },
});
